// Task ERRTOAST step 4: stop the server round-trip that produced the blank toast in the first
// place. The New view / New sector dialogs accepted anything in their Code field and only failed
// server-side, with the backend DTO's raw regex printed under the input as the admin's only
// guidance. Both fields share one shape — lowercase letters, digits and underscores, bounded
// length — so they share one check and one plain-English explanation.
//
// The bounds mirror the admin-service DTOs: views allow 31 characters, sectors 15.
export const VIEW_CODE_MAX_LENGTH = 31;
export const SECTOR_CODE_MAX_LENGTH = 15;

const CODE_CHARS = /^[a-z0-9_]+$/;

/**
 * Does `value` satisfy `^[a-z0-9_]{1,maxLength}$`? Callers pass the trimmed field value.
 *
 * Only meaningful in create mode — both dialogs disable the Code input when editing, and an
 * existing row's code must never be second-guessed by the console.
 */
export function isValidCode(value: string, maxLength: number): boolean {
  return value.length > 0 && value.length <= maxLength && CODE_CHARS.test(value);
}
